module.exports = __webpack_public_path__ + "img/choose-img_en.e98eda20.png";